import { createRootRouteWithContext, HeadContent, Outlet } from '@tanstack/react-router';

import { Error } from '@src/components/utils';
import { buildOrganizationSchema, jsonLdScript } from '@src/corelib/seo';
import NotFoundComponent from '@src/pages/NotFoundComponent';

const component = () => (
  <>
    <HeadContent />
    <Outlet />
  </>
);
const errorComponent = () => <Error />;

// Organization JSON-LD applies site-wide, so it lives on the root route
// rather than being repeated in every route's head(). The default title is
// here too, for routes with no head() of their own (e.g. /app, /auth) --
// child routes' head() titles override it (TanStack merges meta by key,
// child wins). index.html intentionally has no static <title> any more: a
// static one there raced with this one instead of being replaced by it,
// producing two <title> elements in the raw HTML -- harmless to browsers
// (the first wins per spec) but invalid, and now that M3 bakes this HTML
// into static snapshots for crawlers, worth not shipping.
const head = () => ({
  meta: [{ title: 'SecureOneLabs' }],
  scripts: [jsonLdScript(buildOrganizationSchema())],
});

// TanStack Router expects the field name `notFoundComponent`; the component itself is now PascalCase to satisfy rules-of-hooks.
const options = {
  component,
  head,
  notFoundComponent: NotFoundComponent,
};

if (import.meta.env.MODE === 'production') {
  options.errorComponent = errorComponent;
}

export const Route = createRootRouteWithContext()(options);
